@if(model) {
<div class="w-12 ratio-3-4">
    <img class="rf"
         [image]="model.data.image" />
</div>
<p class="m-t-1 p2 truncate">{{model.data.name}}</p>
<p class="p2 col-11">
    @if (model.data.is_from_price) {
    <span class="m-r-1">{{'from' | translate}}</span>
    }
    <!-- final price -->
    <price class="m-r-1"
           [value]="model.price"></price>
    <!-- org price for discount -->
    @if (model.orgPrice) {
    <price class="col-12 line-through"
           [value]="model.orgPrice"></price>
    }
    }
